<template>
  <div class="Redeem" :style="{
      backgroundImage: isConcert('heroes') ? `url('/img/background.png')` : 'none'
    }">
    <div class="Redeem__form" :style="{
      height: isConcert('heroes') ? '574px' : 'auto',
    }">
      <div class="Redeem__form__container">
        <img v-if="isConcert('heroes')" src="/img/futurissima.png" class="img-fluid mb-4" alt="Futurissima">
        <div class="Redeem__form__padding">
          <div class="Redeem__form__info">{{ $t('Inserisci il codice ricevuto') }}</div>
          <label>{{ $t('Codice') }}</label>
          <input type="text" v-model="ticket_id">
          <span class="tokBtn" @click="redeemTicket">
                {{ $t('Entra') }}
              </span>
          <div class="Redeem__form__noCode">{{ $t('Non hai un codice') }}</div>
          <a class="Redeem__form__buyTicket" href="http://www.futurissima.net">{{ $t('Acquista un biglietto') }}</a>
          <a class="Redeem__form__needHelp" href="mailto:alive@tok.tv">{{ $t('Hai bisogno di aiuto') }}</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapActions,
  mapState,
  mapMutations,
  mapGetters,
} from 'vuex';

export default {
  name: 'Redeem',
  data() {
    return {
      ticket_id: '',
    };
  },
  methods: {
    ...mapMutations(['initModal', 'closeRedeem']),
    ...mapActions(['appReady', 'getMe', 'getPlans', 'playVideoById', 'loadTheVideo']),
    isConcert(name) {
      return this.$store.state.singleV === this.$store.state.concertMap[name];
    },
    redeemTicket() {
      if (!this.ticket_id) {
        this.initModal({
          display: true,
          title: this.$t('Errore!'),
          text: this.$t('BLANK_REDEEAM_CODE'),
          cta: this.$t('Close'),
          callback: 'close',
          animation: 'tada',
        });
        return;
      }
      const that = this;
      this.api.post('/claim-plan',
        {
          type: 'ticket',
          ticket_sku: that.redeem.offers[0],
          ticket_id: that.ticket_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'x-tok-token': that.getToken,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.valid) {
            that.getMe()
              .then(() => {
                const withURL = that.conf[that.env].wythUrlRegister.replace('$token', that.getToken);
                document.location = withURL;
                /*
                that.closeRedeem();
                if (that.redeem.play === true) {
                  that.playVideoById(that.redeem);
                }
                if (that.redeem.load === true) {
                  that.loadTheVideo(that.redeem);
                }
                */
              });
          } else {
            that.closeRedeem();
            that.initModal({
              display: true,
              title: this.$t('Errore!'),
              text: this.$t('Wrong Code'),
              cta: this.$t('Close'),
              callback: 'close',
              animation: 'tada',
            });
            that.ticket_id = '';
          }
          /*
          if (response.data.valid) {
            const plan = find(get(that, 'availablePlans.plans', false), p => p.title === response.data.plan);
            if (plan) {
              window.ga('tok.send', 'event', 'Subscription Paywall', 'Pay Item Acquired', get(plan, 'id'));
            }
            that.getMe()
              .then(() => {
                that.getPlans(true)
                  .then(() => {
                    that.$router.push('/paywall');
                  })
                  .catch(() => {
                    window.app.$log.info('Unable retrive plans');
                    that.$router.push('/paywall');
                  });
              })
              .catch(() => {
                window.app.$log.info('Unable to retrive user info');
                that.$router.push('/paywall');
              });
          } else {
            that.initModal({
              display: true,
              title: 'ERROR',
              text: 'generic error',
              cta: this.$t('Close'),
              callback: 'closeAnPayWall',
              animation: 'tada',
            });
          }
          */
        })
        .catch(() => {
          that.initModal({
            display: true,
            title: this.$t('Errore!'),
            text: 'Payment processing error',
            cta: this.$t('Close'),
            callback: 'close',
            animation: 'tada',
          });
        });
    },
  },
  computed: {
    ...mapState(['api', 'availablePlans', 'redeem', 'conf', 'env']),
    ...mapGetters(['getToken']),
  },
};
</script>

<style scoped lang="scss">
.Redeem {
  background-size: cover;
  width: 100%;
  min-height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,1);

  &__form {
    background-color: rgb(25, 25, 25);
    padding: 0;
    // height: 574px;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    width: 100%;
    max-width: 773px;
    margin: 20px;
    border: 1px solid white;
    align-items: center;
    &__container{
      display: flex;
      flex-direction: column;
      height: 100%;
    }
    &__padding{
      display: flex;
      flex-direction: column;
      height: 100%;
      padding: 30px;
      width: fit-content;
      margin: 0 auto;
    }
    &__info {
      color: white;
      font-size: 22px;
      text-align: center;
      margin-bottom: 40px;
    }
    &__noCode{
      text-align: center;
      color: white;
      margin-top: 40px;
      border-bottom: 1px solid white;
      padding-bottom: 5px;
      margin-bottom: 5px;
    }
    &__buyTicket{
      text-align: center;
      color: #F9805F;
      text-decoration: underline;
    }
    &__needHelp{
      display: flex;
      flex: auto;
      color: #F9805F;
      text-decoration: underline;
      align-items: flex-end;
      justify-content: center;
    }
    label {
      color: rgba(255, 255, 255, 0.8);
      margin-bottom: 5px;
      text-align: center;
    }

    input {
      margin-bottom: 20px;
      padding: 8px;
      border-radius: 5px;
      border: 1px solid white;
      font-size: 16px;
      background-color: rgb(25, 25, 25);
      color: white;
    }

    .tokBtn {
      margin-top: 20px;
      background-color: #F9805F;
      color: black;
      border: 1px solid white;
      height: 40px;
    }
  }
}
</style>
